export default __webpack_public_path__ + "static/media/icon-logout.b35838a7.svg";